import React from "react";
import cx from "classnames";
import styles from "../../scss/AFDialog.module.scss";
import LModal from "../../../common/components/Modals/LModal/LModal";
import Icon from "../../../common/components/Icon/Icon";

interface IAFReferBonusTCDialog {
    isOpen: boolean;
    onClose: (isContinue: boolean) => void;
    content: string;
}

const AFReferBonusTCDialog: React.FC<IAFReferBonusTCDialog> = (props) => {
    const { isOpen, onClose, content } = props;

    return (
        <LModal
            Header={() => null}
            calcHeightMode="auto"
            width="normal"
            removePadding={true}
            isOpen={isOpen}
            onClose={() => onClose(false)}>
            {() => {
                return (
                    <div className={styles["af-terms-dialog-modal"]}>
                        <a
                            href="#"
                            className={styles["af-terms-dialog__close-btn"]}
                            onClick={() => onClose(false)}>
                            <Icon alt="close icon" id={"CloseSidebar"} size="ml" />
                        </a>
                        <div
                            className={cx(
                                styles["af-terms-dialog-content"],
                                styles["af-refer-terms"]
                            )}
                            dangerouslySetInnerHTML={{ __html: content }}></div>
                    </div>
                );
            }}
        </LModal>
    );
};

export default AFReferBonusTCDialog;
